import ReactCarousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import './Carousel.scss';
import Card from "./Card";

const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

const Carousel = ({items} : {
    items?: string;
}) => {
    return (
        <ReactCarousel 
            responsive={responsive}
            showDots={true}
            ssr={true}
            infinite={true}
            autoPlaySpeed={1000}
            keyBoardControl={true}
            transitionDuration={500}
            removeArrowOnDeviceType={["tablet", "mobile"]}
            renderButtonGroupOutside
        >
            <Card>
                <h3 className='card-title a'>✨ Authenticity</h3>
                <p>We value authenticity to the highest degree and understand how 
                    important it is to be transparent and honest. We only create high-quality 
                    and real work: real data backed by real-world experiences.
                </p>
            </Card>
            <Card>
                <h3 className='card-title a'>⚖️ Equity</h3>
                <p>We understand that not everything has a one-size-fits-all solution, and sometimes things look different for different people. We practice equity across all sectors and interactions.
                </p>
            </Card>
            <Card>
                <h3 className='card-title a'>🧠 Innovation</h3>
                <p>
                Our philosophy is to continue pushing past the status quo, being bold and curious, and learning from our wins and losses. We value learning and education to the highest degree.
                </p>
            </Card>
            <Card>
                <h3 className='card-title a'>💛 Compassion</h3>
                <p>
                We’re committed to empathy, kindness, and dismantling the oppressive systems and structures around us. Understanding is at the forefront of our operations, and solidarity is important to us. 
                </p>
            </Card>
            <Card>
                <h3 className='card-title a'>🌈 Diversity</h3>
                <p>
                We foster a diverse, supportive, and inclusive environment. We believe that people across different backgrounds and identities encourage innovation and creativity.
                </p>
            </Card>
            <Card>
                <h3 className='card-title a'>🫂 Community</h3>
                <p>
                We operate internally through open conversation and democracy. We believe that our individual roles rely on the overall wellbeing of the collective, so we actively invest in one another.
                </p>
            </Card>
        </ReactCarousel>
    )
}

export default Carousel;